import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2CopyToClipboardOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32"><path d="M28 22v4h2v-4zm2-8V4h-7.65V2H9.64v2H2v26h26.84L30 28H4V6h5.64v2h12.71V6H28v8zm-9.65-8h-8.71V4h8.71zM14 12v2H6v-2zm0 10v2H6v-2zm-2-4.877v2H6v-2zm18 .008v2H17.69l5.6 5.59-1.42 1.42-8-8.01 8.02-8.03 1.42 1.41-5.62 5.62z" /></svg>
);
